{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Επιλέξτε ένα αντικείμενο",
  "tableResizer": "Αλλαγή μεγέθους",
  "colorSwatchPicker": "Color swatches"
}
